import Select from 'react-select'
import {getCSSVariableValue} from '../../../_metronic/assets/ts/_utils'

const CustomSelect = ({
  options = [{name: 'Provide options'}],
  optionValue = 'name',
  optionLabel = 'name',
  onChange,
  isMulti = false,
  disabled = false,
  size = 'md',
  ...props
}) => {
  const sizeStyles = {
    xs: {
      baseUnit: 3,
      controlHeight: 4,
      fontSize: '1em',
    },
    sm: {
      baseUnit: 4,
      controlHeight: 4,
      fontSize: '1em',
    },
    md: {
      baseUnit: 5.2,
      controlHeight: 5.2,
      fontSize: '1.075em',
    },
    lg: {
      baseUnit: 7,
      controlHeight: 7,
      fontSize: '1.3em',
    },
  }

  const selectedSize = sizeStyles[size] || sizeStyles.md

  return (
    <Select
      isClearable
      isMulti={isMulti}
      isSearchable
      isDisabled={disabled}
      options={options}
      onChange={onChange}
      className="border-0"
      getOptionValue={(option) => option[optionValue]}
      getOptionLabel={(option) => option[optionLabel]}
      theme={(theme) => ({
        ...theme,
        spacing: {
          ...theme.spacing,
          baseUnit: selectedSize.baseUnit,
          controlHeight: selectedSize.controlHeight,
        },
      })}
      styles={{
        placeholder: (provided) => ({
          ...provided,
          fontSize: selectedSize.fontSize,
          fontWeight: '500',
          color: getCSSVariableValue('--bs-gray-500'),
        }),
        control: (provided) => ({
          ...provided,
          borderRadius: '0.475em',
          boxShadow: 'none',
          border: '1px solid ' + getCSSVariableValue('--bs-gray-400'),
        }),
      }}
      {...props}
    />
  )
}

export default CustomSelect
